import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { UserService } from '../services/user/user.service';
import { hasPremiumAccess } from '../models/user-profile';

/**
 * Guard that redirects users to the appropriate home page based on premium status.
 * - Pro/Premium users → /timeline
 * - Free users → /gallery
 */
export const homeRedirectGuard = (): Observable<UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.userProfile$.pipe(
    filter((profile) => profile !== null),
    take(1),
    map((profile) => {
      if (hasPremiumAccess(profile)) {
        return router.createUrlTree(['/timeline']);
      }
      return router.createUrlTree(['/gallery']);
    })
  );
};

